import type { KeyboardEvent } from 'react';

/**
 * AntD's DatePicker only commits a cleared value through its own "x" icon.
 * Backspacing every character of the masked text empties the DISPLAY, but
 * rc-picker never calls `onChange` for that — on blur it just resyncs the
 * display back to the last committed `value` prop, so the date silently
 * reappears. Reported by advisors/approvers using Preview: the date looks
 * deleted right up until they click off the field.
 *
 * Must be wired to `onKeyUp` on a DOM ancestor of the DatePicker (event
 * bubbling), not passed as a prop to `<DatePicker>` itself — antd's
 * DatePicker doesn't forward an unrecognised `onKeyUp` prop down to the
 * underlying `<input>`.
 */
export function clearOnEmptyBackspace(onClear: () => void) {
  return (event: KeyboardEvent<HTMLElement>) => {
    if (event.key !== 'Backspace' && event.key !== 'Delete') return;
    const target = event.target as HTMLInputElement;
    if (target?.value === '') onClear();
  };
}
